<div class="sidebar-footer">
  <div class="sidebar-footer-wrapper">
    <!-- User Profile Button Dropdown -->
    <div
      class="footer-item footer-user-wrap"
      ngbDropdown
      container="body"
      placement="right-bottom right-top right-start right-end"
    >
      <button
        ngbDropdownToggle
        type="button"
        class="btn btn-block user-profile-btn d-flex align-items-center justify-content-between mt-25"
      >
        <div class="d-flex align-items-center text-truncate">
          <div class="avatar bg-danger text-white mr-50">
            <span class="avatar-content font-weight-bold">{{ currentUserInitial }}</span>
          </div>
          <div class="user-info text-truncate text-left">
            <div class="user-name text-truncate">{{ currentUserEmail }}</div>
          </div>
        </div>
        <lucide-angular name="chevrons-up-down" [size]="16" class="chevron-icon ml-auto"></lucide-angular>
      </button>

      <div ngbDropdownMenu class="dropdown-menu">
        <a ngbDropdownItem [routerLink]="['/profile']" class="d-flex align-items-center">
          <lucide-angular name="user" [size]="16" class="mr-50"></lucide-angular>
          Hồ sơ
        </a>
        <a ngbDropdownItem (click)="toggleDarkSkin()" class="d-flex align-items-center">
          <lucide-angular [name]="currentSkin === 'dark' ? 'sun' : 'moon'" [size]="16" class="mr-50"></lucide-angular>
          {{ currentSkin === 'dark' ? 'Giao diện sáng' : 'Giao diện tối' }}
        </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()" class="d-flex align-items-center text-danger">
          <lucide-angular name="power" [size]="16" class="mr-50"></lucide-angular>
          Đăng xuất
        </a>
      </div>
    </div>
  </div>
</div>
